<template>
  <div>
    <Head />
    <div class="mainC">
      <router-view></router-view>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "@/components/head";
import Foot from "@/components/foot";

export default {
  name: "layout",
  components: { Head, Foot },
};
</script>

<style lang="scss">
.mainC {
  padding-top: 79px;
}

</style>